import React, {useState} from 'react';
import {Box, VStack, HStack, PinInput, PinInputField, useTheme, Button} from '@chakra-ui/react';
import {TextG14, TextG24} from '../../components/typography';

interface Intro4VerifyProps {
  onValidationChange: (isValid: boolean) => void;
  onDataChange: (code: string) => void;
  phoneNumber: string;
  onResendCode: () => void;
}

const IntroVerify = ({onValidationChange, onDataChange, phoneNumber, onResendCode}: Intro4VerifyProps) => {
  const theme = useTheme();
  const [code, setCode] = useState('');

  const handleCodeChange = (value: string) => {
    setCode(value);
    const isValid = value.length === 6;
    onValidationChange(isValid);
    onDataChange(value);
  };

  // Format phone number for display
  const formatPhoneDisplay = (phone: string) => {
    const digitsOnly = phone.replace(/\D/g, '');
    if (digitsOnly.length === 11) {
      // Remove country code and format
      return `(${digitsOnly.slice(1, 4)}) ${digitsOnly.slice(4, 7)}-${digitsOnly.slice(7, 11)}`;
    }
    return phone;
  };

  return (
    <VStack
      flex={1}
      spacing={6}
      px={4}
      pt={4}
      pb={4}
      align="stretch"
      justify="flex-start"
      overflow="auto">
      {/* Title */}
      <Box>
        {/* <TextG24 fontSize="32px" fontWeight="700" color="#262626">
          Enter your
        </TextG24>
        <TextG24 fontSize="32px" fontWeight="700" color="#262626">
          verification code
        </TextG24> */}
        <TextG24 fontSize="26px" fontWeight="700" color="#262626">
          What's your number?
        </TextG24>
      </Box>

      {/* Description */}
      <TextG14 color="#262626" fontWeight="500" lineHeight="22px" mt={-2}>
        Enter the code we sent over SMS to {formatPhoneDisplay(phoneNumber)}:
      </TextG14>

      {/* PIN Input */}
      <Box display="flex" justifyContent="center" py={4}>
        <HStack spacing={3}>
          <PinInput
            value={code}
            onChange={handleCodeChange}
            type="alphanumeric"
            size="lg"
            placeholder=""
            manageFocus={true}
            autoFocus={true}>
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
            <PinInputField
              borderRadius="12px"
              border="2px solid"
              borderColor={theme.colors.gray[300]}
              _focus={{
                borderColor: '#C9136B',
                boxShadow: 'none',
              }}
              fontSize="24px"
              fontWeight="700"
              w="50px"
              h="60px"
            />
          </PinInput>
        </HStack>
      </Box>

      {/* Resend Code */}
      <Box textAlign="center">
        <Button
          variant="link"
          color="#C9136B"
          fontSize="14px"
          fontWeight="600"
          onClick={onResendCode}>
          Resend Code
        </Button>
      </Box>
    </VStack>
  );
};

export default IntroVerify;
